import { CSSProperties } from 'react';

import { faEye, faEyeSlash } from '@fortawesome/pro-light-svg-icons';
import { useRecoilValue } from 'recoil';

import {
  AbsenceTypeFormation,
  AdditionalFormationCategory,
  EmployeeFormation
} from 'components/types';

import { displayPercentage } from 'utils/misc';

import { updateEmploymentSettingsAtom } from '../../atoms';

import { IconButton, TableCell } from '@mui/material';

import { FontAwesomeSvgIcon } from 'components/shared';
import {
  NumericTableCell,
  ZebraStripedTableRow
} from 'components/shared/Table';

import {
  EmployeeNameCell,
  isFormationAbsenceTypeFormation,
  isFormationAdditionalTypeFormation,
  isFormationEmployeeFormation,
  renderFixedCellsForFormationDetail
} from '../../util';

type Props = {
  formation:
    | EmployeeFormation
    | AdditionalFormationCategory
    | AbsenceTypeFormation;
  style?: CSSProperties;
  shouldShowExcludeOption?: boolean;
};

const DetailRow = ({ formation, style, shouldShowExcludeOption }: Props) => {
  const updateEmployeeSettingsFn = useRecoilValue(updateEmploymentSettingsAtom);
  const onClickExclude = () => {
    updateEmployeeSettingsFn({
      employmentId: (formation as EmployeeFormation).employment.id,
      excluded: !(formation as EmployeeFormation).excludedFromScenario
    });
  };

  return (
    <ZebraStripedTableRow style={style}>
      <NumericTableCell
        width={isFormationAdditionalTypeFormation(formation) ? 70 : 16}
      />
      {!isFormationAbsenceTypeFormation(formation) && (
        <>
          {shouldShowExcludeOption && (
            <TableCell width="46px">
              <IconButton size="small" onClick={onClickExclude}>
                <FontAwesomeSvgIcon
                  icon={formation.excludedFromScenario ? faEyeSlash : faEye}
                  fontSize="small"
                />
              </IconButton>
            </TableCell>
          )}
          {isFormationEmployeeFormation(formation) && (
            <EmployeeNameCell formation={formation} />
          )}
          <TableCell
            sx={{
              backgroundColor: formation.function?.colorCode ?? null,
              minWidth: '8px',
              width: '8px',
              padding: 0
            }}
          />
          <TableCell>{formation.function?.description ?? ''}</TableCell>
        </>
      )}
      {renderFixedCellsForFormationDetail(formation)}
      {formation.periodHours.map((period) => (
        <NumericTableCell key={`${formation.uuid}_period_${period.number}`}>
          {period.hours ? Math.round(period.hours) : ''}
        </NumericTableCell>
      ))}
      <NumericTableCell width={68}>
        {formation.totalYearHours !== 0
          ? Math.round(formation.totalYearHours)
          : ''}
      </NumericTableCell>
      <NumericTableCell width={68}>
        {formation.formationPercentage
          ? displayPercentage(formation.formationPercentage)
          : ''}
      </NumericTableCell>
    </ZebraStripedTableRow>
  );
};

export default DetailRow;
